import { AlertModelService } from "../alert-model.service";

export class AlertAttachmentsHelper {

  static summaryText(service: AlertModelService, isPublic: boolean): string {
    const count = isPublic ? (service?.alertMessage?.files?.length ?? 0) : (service?.selectedFiles?.length ?? 0);
    return `${count} file(s)`;
  }

}